import decode from 'jwt-decode';
import getTokens from '../../../utils/getTokens';
import {
  POSTS_LIKE_UNLIKE,
  ALL_POSTS_LIKES,
  ONE_POST_LIKE,
  ALL_POST_COMMENT_LIKES,
  COMMENT_LIKE_UNLIKE,
} from './types';

const tokens = getTokens();
const ownerId = tokens
  ? decode(JSON.parse(tokens).access).customer_id : '';

export default {
  [POSTS_LIKE_UNLIKE]: (state, payload) => {
    let postsLikes = [];
    if (payload.add) {
      postsLikes = state.postsLikes.map(({ user, url, likes }) => {
        if (user === payload.user && url === payload.url) {
          // eslint-disable-next-line no-param-reassign
          likes[ownerId] = {
            first_name: payload.add.first_name,
            last_name: payload.add.last_name,
            image_url: payload.add.profile_picture,
            job_title: payload.add.job_title,
            company_name: payload.add.company_name,
          };
        }
        return {
          likes,
          url,
          user,
        };
      });
    } else {
      postsLikes = state.postsLikes.map(({ user, url, likes }) => {
        if (user === payload.user && url === payload.url) {
          // eslint-disable-next-line no-param-reassign
          delete likes[ownerId];
        }
        return {
          likes,
          url,
          user,
        };
      });
    }
    state.postsLikes = postsLikes;
  },
  [ALL_POSTS_LIKES]: (state, payload) => {
    const postsLikes = payload.posts.map(post => ({
      url: post.url,
      user: post.user,
      likes: post.like_details,
    }));
    state.postsLikes = postsLikes;
  },
  [ONE_POST_LIKE]: (state, payload) => {
    const postLike = {
      likes: payload.post.like_details,
      url: payload.post.url,
      user: payload.post.user,
    };
    state.postsLikes.unshift(postLike);
    state.postsLikes = state.postsLikes.slice();
  },
  [ALL_POST_COMMENT_LIKES]: (state, payload) => {
    const commentLikes = payload.posts.map(comm => ({
      isLiked: Object.prototype.hasOwnProperty.call(comm.likes, ownerId),
      likes: comm.likes,
      count: Object.keys(comm.likes).length,
      url: comm.url,
    }));
    state.commentLikes = [...state.commentLikes, ...commentLikes];
  },
  [COMMENT_LIKE_UNLIKE]: (state, payload) => {
    let commentLikes = [];
    if (payload.add) {
      commentLikes = state.commentLikes.map((like) => {
        if (like.url === payload.url) {
          // eslint-disable-next-line no-param-reassign
          like.likes[ownerId] = {
            first_name: payload.add.first_name,
            last_name: payload.add.last_name,
            image_url: payload.add.profile_picture,
            job_title: payload.add.job_title,
            company_name: payload.add.company_name,
          };
          // eslint-disable-next-line no-param-reassign
          like.count += 1; like.isLiked = true;
        }
        return like;
      });
    } else {
      commentLikes = state.commentLikes.map((like) => {
        if (like.url === payload.url) {
          // eslint-disable-next-line no-param-reassign
          delete like.likes[ownerId];
          // eslint-disable-next-line no-param-reassign
          like.count -= 1; like.isLiked = false;
        }
        return like;
      });
    }
    state.commentLikes = commentLikes;
  },
};
